import styled from 'styled-components';
import { ErrorMessage } from 'formik';
import { media } from 'styles/Mixins';
import { PrimaryButton, TextStyledButton } from 'styles/Buttons';
import { FlexColumn } from 'styles/Layout';
import { StyledSelect as SelectStyled } from 'styles/StyledFormFormik';

export const SubtitleInput = styled.div`
  min-height: 17px;
  font-size: 14px;
  line-height: 17px;
  color: #9b9b9b;
  max-width: 300px;
  text-align: left;
`;

export const BackButtonContainer = styled.div`
  display: ${({ isVisible = true }) => (isVisible ? 'block' : 'none')};
  width: 119px;
  color: #4a4a4a;
  position: relative;
  cursor: pointer;
  ${media.md`
    position: absolute;
    top: 0;
    left: 0;
    margin-top: ${props => (props.addMargin ? 20 : 0)}px;
    margin-left: ${props => (props.addMargin ? 20 : 0)}px;
  `}
`;

export const SubmitButton = styled(PrimaryButton)`
  width: 100%;
  margin-bottom: 15px;
`;

export const AppTabContainer = styled(FlexColumn)`
  width: 100%;
  position: relative;
`;
export const AppTabForm = styled(FlexColumn)`
  width: 300px;
  margin: 5px auto;
`;

export const Title = styled.span`
  display: block;
  min-height: 22px;
  width: 100%;
  color: #4a4a4a;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 5px;
`;
export const Description = styled.div`
  font-weight: 400;
  min-height: 22px;
  width: 100%;
  color: #9b9b9b;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 20px;
`;
export const Subtitle = styled(Title)`
  min-height: 19px;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 10px;
`;
export const Text = styled.span`
  display: block;
  min-height: 17px;
  font-size: 13px;
  line-height: 17px;
  color: #4a4a4a;
  margin-bottom: 10px;
`;
export const StyledOptionalInput = styled.div`
  position: relative;
  margin-bottom: 20px;
`;
export const StyledValidatedInput = styled(StyledOptionalInput)`
  position: relative;
  margin-bottom: 20px;
`;
export const StyledNumberInput = styled(StyledOptionalInput)`
  display: flex;
`;
export const StyledErrorMessage = styled(ErrorMessage)`
  color: red;
  position: absolute;
  top: 35px;
  font-size: 14px;
`;
export const StyledPhoneErrorMessage = styled(StyledErrorMessage)`
  position: static;
  text-align: left;
  top: 0;
`;

export const StyledSelect = styled(SelectStyled)`
  position: relative;
  padding: 0 15px 0 5px;
  text-indent: 5px;
`;

export const StyledFmkInput = styled(SelectStyled)`
  padding: 10px 15px;
  font-weight: bold;
  color: #4a4a4a;
  &::placeholder {
    font-weight: 500;
    color: #9b9b9b;
  }
  &:disabled {
    background: #ececec;
    color: #9b9b9b;
  }
`;

export const StyledInput = styled.input`
  display: block;
  width: 100%;
  height: 35px;
  padding: 10px 15px;
  border: 1px solid #ececec;
  border-radius: 2px;
  background-color: white;
  line-height: 35px;
  font-size: 16px;
  font-weight: bold;
  color: #4a4a4a;
  &::placeholder {
    font-weight: 500;
    color: #9b9b9b;
  }
  &:disabled {
    background: #ececec;
    color: #9b9b9b;
  }
`;

export const StyledIconInput = styled(StyledInput)`
  padding: 10px 15px 10px 45px;
`;
export const InputIcon = styled.div`
  position: absolute;
  left: 15px;
  top: 10px;
  height: 15px;
  width: 15px;
  & svg {
    height: 15px;
    width: 15px;
  }
`;
export const StyledInputInstructions = styled.span`
  display: block;
  width: 279px;
  color: #9b9b9b;
  font-size: 13px;
  line-height: 17px;
  margin-top: 4px;
`;
export const InputPhoneCode = styled.div`
  font-weight: bold;
`;

export const EndSectionSpace = styled.div`
  display: block;
  height: 10px;
`;

export const RowInputsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
export const RowStyledInputContainer = styled.div`
  width: 140px;
`;

export const CancelAppButton = styled(TextStyledButton)`
  position: relative;
  color: ${({ color = '#4a4a4a' }) => color};
  margin: 0 auto 10px auto;
  ${media.md`
    position: absolute;
    top: 0;
    right: 0;
    margin: 2px 4px;
    width: auto;
  `}
`;
